<script>
import Select from '@wielink-application/shared/vue/components/form/input-only/select.vue'

export default Select;
</script>